import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-submenu',
  templateUrl: './submenu.component.html',
  styleUrls: ['./submenu.component.less']
})
export class SubmenuComponent implements OnInit {
  @Input() options: Array<string>;
  @Output() selectedOption: EventEmitter<number>;
  @ViewChild('dd') dropdown: ElementRef;

  constructor() {
    this.options = [];
    this.selectedOption = new EventEmitter<number>();
  }

  ngOnInit() {
  }

  handleOptionClick(e: Event, option: string) {
    this.dropdown.nativeElement.classList.toggle('active');
    this.selectedOption.emit(this.options.findIndex(o => o === option));
    e.stopPropagation();
  }
}

export interface SubmenuOption {
  labelFr: string;
  handler: Function;
}



// WEBPACK FOOTER //
// ./src/app/element/submenu/submenu.component.ts